import React, { FC, useMemo, useState } from "react";
import { Animated } from "react-animated-css";
import { Link } from "react-router-dom";
import { useUsers } from "../api/hooks";
import Footer from "../common/views/Footer";
import { UserList } from "./UserList";

export const UserAdminScreen: FC = () => {
  const [activeFilter, setActiveFilter] = useState(true);

  const { data: users = [], isLoading } = useUsers(activeFilter);

  return (
    <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true}>
      <div className="container">
        <div className="row">
          <div className="col">
            <h3 className="my-4 color-green">
              Utilisateurs{" "}
              <small className="color-black">({users.length})</small>
            </h3>
          </div>
          <div className="col text-right tittle-buttons">
            <Link
              type="submit"
              className="btn btn-warning"
              to={`${process.env.PUBLIC_URL}/user/new`}
            >
              Créer utilisateur <i className="fa fa-plus"></i>
            </Link>
          </div>
        </div>

        <UserList
          users={users}
          isLoading={isLoading}
          onActiveChange={(active) => setActiveFilter(active)}
          activeFilter={activeFilter}
        />
      </div>
      <Footer />
    </Animated>
  );
};
